import { render, staticRenderFns } from "./oilCzInfo.vue?vue&type=template&id=50f19054&scoped=true&"
import script from "./oilCzInfo.vue?vue&type=script&lang=js&"
export * from "./oilCzInfo.vue?vue&type=script&lang=js&"
import style0 from "./oilCzInfo.vue?vue&type=style&index=0&id=50f19054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f19054",
  null
  
)

export default component.exports